/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import {
    Breadcrumb, Button, Checkbox, Input, Panel, Table,
} from 'appkit-react';
import { useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Col, Row, Alert } from 'react-bootstrap';
import { scroller } from 'react-scroll';
import { useHistory } from 'react-router-dom';

import {
    showReportMenuVar, leftNavigationItemsVar, moduleIdVar, ruleSummaryPageNumberVar,
    ruleSummaryPageSizeVar, rulePassedVar, ruleFailedVar, ruleErrorVar,
} from 'Apollo/config';
import FFIEC009ReportConfigDetails from 'views/Rules/FFIEC009/components/FFIEC009ReportConfigDetails';
import FRY7QReportConfigDetails from 'views/Rules/FRY7Q/components/FRY7QReportConfigDetails';
import FRY9CReportConfigDetails from 'views/Rules/FRY9C/components/FRY9CReportConfigDetails';
import FFIEC031ReportConfigDetails from 'views/Rules/FFIEC031/components/FFIEC031ReportConfigDetails';
import FFIEC041ReportConfigDetails from 'views/Rules/FFIEC041/components/FFIEC041ReportConfigDetails';
import Metro2ReportConfigDetails from 'views/Rules/Metro2/components/Metro2ReportConfigDetails';
import FR2052AReportConfigDetails from 'views/Rules/FR2052A/components/FR2052AReportConfigDetails';
import { PageSizeOptionEnum } from 'constants';
import { RulesLandingPageNameEnum } from '../../../constants/index';
import Loader from '../../Shared/components/Loader';
import '../Styles/index.scss';
import '../Styles/datepicker.scss';
import PieChart from './PieChart';

const canNavigateToResult = (data, pageName) => {
    let canNavigate;
    if (pageName === RulesLandingPageNameEnum.METRO2 && data.original.batchRunStatus === 'Completed') {
        canNavigate = true;
    } else if (pageName === RulesLandingPageNameEnum.FFIEC009 && data.original.batchRunStatus === 'Completed') {
        canNavigate = true;
    } else if (pageName === RulesLandingPageNameEnum.FR2052A && data.original.batchRunStatus === 'Completed' && data.original.isRuleApplicable === 'Y') {
        canNavigate = true;
    } else if (pageName === RulesLandingPageNameEnum.FRY9C && data.original.batchRunStatus === 'Completed' && data.original.isRuleApplicable === 'Y') {
        canNavigate = true;
    } else if (pageName === RulesLandingPageNameEnum.FFIEC031 && data.original.batchRunStatus === 'Completed' && data.original.isRuleApplicable === 'Y') {
        canNavigate = true;
    } else if (pageName === RulesLandingPageNameEnum.FFIEC041 && data.original.batchRunStatus === 'Completed' && data.original.isRuleApplicable === 'Y') {
        canNavigate = true;
    } else {
        canNavigate = false;
    }
    return canNavigate;
};

const DiagnosticResultsUI = ({
    breadcrumbItems, commonData, columns, summaryQuartersData, selectedQuarter,
    setSelectedQuarter, uploadReport, onNavigateToResult, pageName, downloadResult,
    isDownloading, isBatchTestDataLoading, latestBatch, showSuccessAlert,
    getLatestBatch, showBatchAlert, queryError,
}) => {
    const history = useHistory();
    const ruleSummaryPageNumber = useReactiveVar(ruleSummaryPageNumberVar);
    const ruleSummaryPageSize = useReactiveVar(ruleSummaryPageSizeVar);
    const rulePassed = useReactiveVar(rulePassedVar);
    const ruleFailed = useReactiveVar(ruleFailedVar);
    const ruleError = useReactiveVar(ruleErrorVar);
    const [searchPassed, setSearchPassed] = useState(rulePassed);
    const [searchFailed, setSearchFailed] = useState(ruleFailed);
    const [searchError, setSearchError] = useState(ruleError);
    const [notApplicable, setNotApplicable] = useState(false);
    const [filterString, setFilterString] = useState('');
    const [filterValue, setFilterValue] = useState('');

    const {
        FIVE, TEN, FIFTEEN, TWENTY, TWENTYFIVE,
    } = PageSizeOptionEnum;
    const pageSizeOptions = [FIVE, TEN, FIFTEEN, TWENTY, TWENTYFIVE];
    const [pages, setPages] = useState(null);
    const [pagesize, setPagesize] = useState(ruleSummaryPageSize);
    const [pageNumber, setPageNumber] = useState(ruleSummaryPageNumber);

    const [tableData, setTableData] = useState(commonData);

    const isLatestBatchRunStatusFailed = (latestBatch && (latestBatch[0] || []).batchRunStatus === 'Failed');

    const scrollToSection = () => {
        scroller.scrollTo('table-container', {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
        });
    };

    const resetStatusCheckboxForAll = () => {
        if (searchPassed) {
            setSearchPassed(!searchPassed);
            rulePassedVar(!searchPassed);
        }
        if (searchFailed) {
            setSearchFailed(!searchFailed);
            ruleFailedVar(!searchFailed);
        }
        if (searchError) {
            setSearchError(!searchError);
            ruleErrorVar(!searchError);
        }
    };

    const resetStatusCheckboxForPassed = () => {
        if (searchFailed) {
            setSearchFailed(!searchFailed);
            ruleFailedVar(!searchFailed);
        }
        if (searchError) {
            setSearchError(!searchError);
            ruleErrorVar(!searchError);
        }
    };

    const resetStatusCheckboxForFailed = () => {
        if (searchPassed) {
            setSearchPassed(!searchPassed);
            rulePassedVar(!searchPassed);
        }
        if (searchError) {
            setSearchError(!searchError);
            ruleErrorVar(!searchError);
        }
    };

    const resetStatusCheckboxForError = () => {
        if (searchPassed) {
            setSearchPassed(!searchPassed);
            rulePassedVar(!searchPassed);
        }
        if (searchFailed) {
            setSearchFailed(!searchFailed);
            ruleFailedVar(!searchFailed);
        }
    };

    useEffect(() => {
        if (commonData) {
            setTableData(commonData);
            showReportMenuVar(true);
        }
    }, [commonData]);

    useEffect(() => {
        const searchString = filterString.trim().toLowerCase();
        if (searchString.length > 0) {
            if (pageName === RulesLandingPageNameEnum.FRY7Q) {
                setTableData(commonData.filter(e => e.mdrmNumber.toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.FRY9C) {
                setTableData(commonData.filter(e => e.mdrm.toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.METRO2) {
                setTableData(commonData.filter(e => e.fieldId.toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.FFIEC009) {
                setTableData(commonData.filter(e => String(e.mdrmNumber).toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.FR2052A) {
                setTableData(commonData.filter(e => String(e.mdrmNumber).toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.FFIEC031) {
                setTableData(commonData.filter(e => String(e.mdrm).toLowerCase().match(searchString)));
            }
            if (pageName === RulesLandingPageNameEnum.FFIEC041) {
                setTableData(commonData.filter(e => String(e.mdrm).toLowerCase().match(searchString)));
            }
        } else {
            setTableData(commonData);
        }
    }, [filterString]);

    useEffect(() => {
        switch (filterValue) {
            case 'ALL': {
                setTableData(commonData);
                resetStatusCheckboxForAll();
                scrollToSection();
                break;
            }
            case 'PASSED': {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Completed'));
                resetStatusCheckboxForPassed();
                setSearchPassed(!searchPassed);
                rulePassedVar(!searchPassed);
                scrollToSection();
                break;
            }
            case 'FAILED': {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Failed'));
                resetStatusCheckboxForFailed();
                setSearchFailed(!searchFailed);
                ruleFailedVar(!searchFailed);
                scrollToSection();
                break;
            }
            case 'ERROR': {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Error'));
                resetStatusCheckboxForError();
                setSearchError(!searchError);
                ruleErrorVar(!searchError);
                scrollToSection();
                break;
            }
            default:
                setTableData(commonData);
                break;
        }
    }, [filterValue]);

    useEffect(() => {
        if (notApplicable) {
            setTableData(commonData.filter(e => e.topTierApplicable === 'n' || e.topTierApplicable === 'N' || e.isRuleApplicable === 'N'));
        } else {
            // eslint-disable-next-line no-lonely-if
            if (searchPassed && searchFailed && searchError) {
                setTableData(commonData || []);
            } else if (searchPassed && !searchFailed && !searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Completed'));
            } else if (!searchPassed && searchFailed && !searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Failed'));
            } else if (!searchPassed && !searchFailed && searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Error'));
            } else if (searchPassed && searchFailed && !searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Completed' || e.testRunStatus === 'Failed'));
            } else if (!searchPassed && searchFailed && searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Failed' || e.testRunStatus === 'Error'));
            } else if (searchPassed && !searchFailed && searchError) {
                setTableData(commonData && commonData.filter(e => e.testRunStatus === 'Completed' || e.testRunStatus === 'Error'));
            } else {
                setTableData(commonData || []);
            }
        }
    }, [commonData, searchPassed, searchFailed, searchError, notApplicable]);

    useEffect(() => {
        const totalPages = Math.ceil(tableData && tableData.length / pagesize);
        setPages(totalPages);
        ruleSummaryPageSizeVar(pagesize);
    }, [pagesize, tableData]);

    useEffect(() => {
        ruleSummaryPageNumberVar(pageNumber);
    }, [pageNumber]);

    if (isBatchTestDataLoading) {
        return (
            <Loader />
        );
    }

    return (
        <div>
            <div className="true-comply-diagnostic-results_layout">
                <div className="true-comply-diagnostic-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />

                    <Row>
                        <Col md={5}>
                            <div className="a-h2 title-label">
                                <span
                                    className="appkiticon icon-left-chevron-outline left-arrow-icon"
                                    onClick={() => {
                                        history.push('/');
                                        leftNavigationItemsVar([]);
                                        moduleIdVar(null);
                                    }}
                                    role="presentation"
                                />
                                {pageName}
                            </div>
                        </Col>
                        <Col style={{ textAlign: 'right' }}>
                            <Button size="lg" onClick={() => uploadReport()}>
                                <span className="appkiticon icon-upload-light-outline" />
                                UPLOAD REPORTS
                            </Button>
                            <Button
                                className="a-btn a-btn-secondary a-btn-lg "
                                kind="secondary"
                                size="lg"
                                style={{ marginLeft: '2rem' }}
                                onClick={() => downloadResult()}
                                isLoading={isDownloading}
                            >
                                <span className="appkiticon icon-download-light-outline" />
                                DOWNLOAD
                            </Button>
                        </Col>
                    </Row>

                    {showBatchAlert && (
                        <div className="true-comply-diagnostic-In_progress_alert">
                            <h6> Rule execution is in progress . . .</h6>
                        </div>
                    )}

                    {showSuccessAlert && (
                        <Alert variant="success">
                            Batch execution is completed,
                            <strong style={{ cursor: 'pointer' }} role="presentation" onClick={() => getLatestBatch()}> Click here </strong>
                            to see the result.
                        </Alert>
                    )}

                    {((showBatchAlert === false) && (queryError || isLatestBatchRunStatusFailed)) && (
                        <div className="true-comply-diagnostic-results_alert">
                            <h6> Error !!!</h6>
                        </div>
                    )}
                    <Row>
                        <Col md={4}>
                            <Panel>
                                <Row style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
                                    <Col>
                                        <span
                                            className="appkiticon icon-ticket-outline icon"
                                            style={{ fontSize: '2rem', color: 'black' }}
                                        />
                                        <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>RULES</span>
                                        <div className="a-h6" style={{ marginTop: '0.5rem' }}>Total rules</div>
                                        <div className="a-h2">{commonData && commonData[0] && commonData[0].totalTestCases}</div>
                                        {commonData === null && <div className="a-h2">NA</div>}
                                    </Col>
                                    <Col>
                                        <div className="a-h6" style={{ marginTop: '2.75rem' }}>Rules applicable</div>
                                        <div className="a-h2">
                                            {commonData && commonData[0] && commonData[0].totalTestExecuted}
                                        </div>
                                        {commonData === null && <div className="a-h2">NA</div>}
                                    </Col>
                                    <Col>
                                        <PieChart
                                            totalTestExecuted={commonData && commonData[0] && commonData[0].totalTestExecuted}
                                            totalTestCompleted={commonData && commonData[0] && commonData[0].totalTestCompleted}
                                            totalTestFailed={commonData && commonData[0] && commonData[0].totalTestFailed}
                                            totalTestInError={commonData && commonData[0] && commonData[0].totalTestInError}
                                        />
                                        <div
                                            className="a-h6"
                                            style={{ color: '#d04a02', cursor: 'pointer', paddingLeft: '1.5rem' }}
                                            onClick={() => setFilterValue('ALL')}
                                            role="presentation"
                                        >
                                            VIEW ALL
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                        <Col>
                            <Panel>
                                <Row style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                                    <Col>
                                        <span
                                            className="appkiticon icon-circle-checkmark-outline icon"
                                            style={{ fontSize: '2rem', color: 'black' }}
                                        />
                                        <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>PASSED TESTS</span>
                                        <div className="a-h2">{commonData && commonData[0] && commonData[0].totalTestCompleted}</div>
                                        {commonData === null && <div className="a-h2">NA</div>}
                                        <div
                                            className="a-h6"
                                            style={{ color: '#d04a02', cursor: 'pointer' }}
                                            onClick={() => setFilterValue('PASSED')}
                                            role="presentation"
                                        >
                                            VIEW ALL
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                        <Col>
                            <Panel>
                                <Row style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                                    <Col>
                                        <span
                                            className="appkiticon icon-circle-delete-outline icon"
                                            style={{ fontSize: '2rem', color: 'black' }}
                                        />
                                        <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>FAILED TESTS</span>
                                        <div className="a-h2">{commonData && commonData[0] && commonData[0].totalTestFailed}</div>
                                        {commonData === null && <div className="a-h2">NA</div>}
                                        <div
                                            className="a-h6"
                                            style={{ color: '#d04a02', cursor: 'pointer' }}
                                            role="presentation"
                                            onClick={() => setFilterValue('FAILED')}
                                        >
                                            VIEW ALL
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                        <Col>
                            <Panel>
                                <Row style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                                    <Col>
                                        <span
                                            className="appkiticon
                                            icon-alert-outline icon"
                                            style={{ fontSize: '2rem', color: 'black' }}
                                        />
                                        <span className="a-h4" style={{ paddingLeft: '0.8rem' }}>TESTS IN ERROR</span>
                                        <div className="a-h2">{commonData && commonData[0] && commonData[0].totalTestInError}</div>
                                        {commonData === null && <div className="a-h2">NA</div>}
                                        <div
                                            className="a-h6"
                                            style={{ color: '#d04a02', cursor: 'pointer' }}
                                            role="presentation"
                                            onClick={() => setFilterValue('ERROR')}
                                        >
                                            VIEW ALL
                                        </div>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Panel
                                title="REPORT CONFIGURATION DETAILS"
                                style={{ marginTop: '1rem' }}
                            >
                                {pageName === RulesLandingPageNameEnum.FRY7Q
                                    && (
                                        <FRY7QReportConfigDetails
                                            selectedFRY7QQuarter={selectedQuarter}
                                            setSelectedFRY7QQuarter={setSelectedQuarter}
                                            summaryQuartersFRY7QData={summaryQuartersData}
                                            commonFRY7QData={commonData && commonData[0] && commonData}
                                        />
                                    )}

                                {pageName === RulesLandingPageNameEnum.FRY9C
                                    && (
                                        <FRY9CReportConfigDetails
                                            selectedFRY9CQuarter={selectedQuarter}
                                            setSelectedFRY9CQuarter={setSelectedQuarter}
                                            summaryQuartersFRY9CData={summaryQuartersData}
                                            commonFRY9CData={commonData && commonData[0] && commonData}
                                        />
                                    )}

                                {pageName === RulesLandingPageNameEnum.FFIEC031
                                    && (
                                        <FFIEC031ReportConfigDetails
                                            selectedFFIEC031Quarter={selectedQuarter}
                                            setSelectedFFIEC031Quarter={setSelectedQuarter}
                                            summaryQuartersFFIEC031Data={summaryQuartersData}
                                            commonFFIEC031Data={commonData && commonData[0] && commonData}
                                        />
                                    )}

                                {pageName === RulesLandingPageNameEnum.FFIEC041
                                    && (
                                        <FFIEC041ReportConfigDetails
                                            selectedFFIEC041Quarter={selectedQuarter}
                                            setSelectedFFIEC041Quarter={setSelectedQuarter}
                                            summaryQuartersFFIEC041Data={summaryQuartersData}
                                            commonFFIEC041Data={commonData && commonData[0] && commonData}
                                        />
                                    )}

                                {pageName === RulesLandingPageNameEnum.METRO2 && (
                                    <Metro2ReportConfigDetails
                                        commonMetro2Data={commonData}
                                        selectedMetro2Quarter={selectedQuarter}
                                        setSelectedMetro2Quarter={setSelectedQuarter}
                                    />
                                )}

                                {pageName === RulesLandingPageNameEnum.FFIEC009
                                    && (
                                        <FFIEC009ReportConfigDetails
                                            selectedFFIEC009Quarter={selectedQuarter}
                                            setSelectedFFIEC009Quarter={setSelectedQuarter}
                                            summaryQuartersFFIEC009Data={summaryQuartersData}
                                            commonFFIEC009Data={commonData}
                                        />
                                    )}

                                {pageName === RulesLandingPageNameEnum.FR2052A
                                    && (
                                        <FR2052AReportConfigDetails
                                            selectedFR2052AQuarter={selectedQuarter}
                                            setSelectedFR2052AQuarter={setSelectedQuarter}
                                            summaryQuartersFR2052AData={summaryQuartersData}
                                            commonFR2052AData={commonData}
                                        />
                                    )}
                            </Panel>
                        </Col>
                    </Row>
                    <Row className="true-comply-diagnostic-results_padding">
                        <Col md={2} className="true-comply-diagnostic-results_filter_column">
                            <span className="a-h3">Rules Table</span>
                            <div className="true-comply-diagnostic-results-search_option">
                                <div>
                                    <div className="form-label">SEARCH</div>
                                    <div className="secondary-input-container a-apply-theme-background-gray-level-2">
                                        <Input
                                            inputBoxSize="sm"
                                            placeholder="Search here"
                                            value={filterString}
                                            onChange={e => setFilterString(e)}
                                        />
                                    </div>
                                </div>
                                <div className="form-label">STATUS</div>
                                <Row>
                                    <Col>
                                        <Checkbox
                                            checked={searchPassed}
                                            onChange={() => {
                                                setSearchPassed(!searchPassed);
                                                rulePassedVar(!searchPassed);
                                            }}
                                        >
                                            <span className="checkbox-label">Passed</span>
                                        </Checkbox>
                                    </Col>
                                    <Col style={{ paddingRight: 0 }}>
                                        <span
                                            className="appkiticon                icon-circle-checkmark-outline"
                                            style={{ color: 'green', fontSize: '1.3rem', float: 'right' }}
                                        />
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
                                    <Col>
                                        <Checkbox
                                            checked={searchFailed}
                                            onChange={() => {
                                                setSearchFailed(!searchFailed);
                                                ruleFailedVar(!searchFailed);
                                            }}
                                        >
                                            <span className="checkbox-label">Failed</span>
                                        </Checkbox>
                                    </Col>
                                    <Col style={{ paddingRight: 0 }}>
                                        <span
                                            className="appkiticon
                                             icon-circle-delete-outline"
                                            style={{ color: '#E0301E', fontSize: '1.3rem', float: 'right' }}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>
                                        <Checkbox
                                            checked={searchError}
                                            onChange={() => {
                                                setSearchError(!searchError);
                                                ruleErrorVar(!searchError);
                                            }}
                                        >
                                            <span className="checkbox-label">Error</span>
                                        </Checkbox>
                                    </Col>
                                    <Col style={{ paddingRight: 0 }}>
                                        <span
                                            className="appkiticon
                                             icon-close-outline"
                                            style={{ color: '#E0301E', fontSize: '1.1rem', float: 'right' }}
                                        />
                                    </Col>
                                </Row>
                                {(pageName === RulesLandingPageNameEnum.FRY7Q || pageName === RulesLandingPageNameEnum.FR2052A || pageName === RulesLandingPageNameEnum.FRY9C) && (
                                    <>
                                        <div className="form-label">Applicable</div>
                                        <Row>
                                            <Col md={9} style={{ paddingRight: 0 }}>
                                                <Checkbox
                                                    checked={notApplicable}
                                                    onChange={() => setNotApplicable(!notApplicable)}
                                                >
                                                    <span className="checkbox-label">Not Applicable</span>
                                                </Checkbox>
                                            </Col>
                                            <Col style={{ paddingRight: 0 }}>
                                                <span
                                                    className="appkiticon icon-alert-outline"
                                                    style={{ color: '#FFB600', fontSize: '1.3rem', float: 'right' }}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </div>
                        </Col>
                        <Col
                            md={9}
                            className="true-comply-diagnostic-results_padding true-comply-diagnostic-results-table_column"
                        >
                            <div className="table-container">
                                <Table
                                    data={tableData || []}
                                    columns={columns}
                                    pages={pages}
                                    page={pageNumber - 1}
                                    defaultPageSize={pagesize}
                                    onPageSizeChange={pageSize => setPagesize(pageSize)}
                                    onPageChange={pageIndex => setPageNumber(pageIndex + 1)}
                                    pageSizeOptions={pageSizeOptions}
                                    sortable
                                    defaultSorted={[
                                        {
                                            id: 'ruleId',
                                            asc: true,
                                        },
                                    ]}
                                    size="lg"
                                    resizable
                                    className="-striped -highlight ReactTable rt-expander"
                                    getTrProps={(state, rowInfo) => ({
                                        onClick: () => {
                                            if (rowInfo.original.topTierApplicable === 'y') {
                                                onNavigateToResult(rowInfo.original);
                                            }
                                            if (canNavigateToResult(rowInfo, pageName)) {
                                                onNavigateToResult(rowInfo.original);
                                            }
                                        },
                                    })}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default DiagnosticResultsUI;
